import React, { useMemo } from "react"
import { useLoader } from "@react-three/fiber"
import { Html } from "@react-three/drei"
import { TextureLoader, LinearFilter } from "three"
import { Text, MultilineText } from "../Text"
import Image from "../Image"
import Plane from "../Plane"
import { Block, useBlock } from "../../blocks"
import Paragraph from "../Paragraph"
import useContentStore from "../../redux/stores/contentStore"
import useTranslator from "../useTranslator"
import logoGenosha from "../../assets/img/genosha.png"

function getSectionOffset({ paragraphs, index, offset }) {
  const prev = paragraphs[index - 1];
  const current = paragraphs[index];

  if (!prev)
    return 1;

  // prev is regular
  if (!prev.hugeText) {
    if (current.hugeText)
      return offset + 0.9;
    return offset + 1; // current is regular
  }

  // prev is hugeText
  if (current.hugeText)
    return offset + 0.9;
  return offset + 1.3; // current is regular
}

export default function Content() {
  const { current: currentPage, content } = useContentStore((state) => state)
  const images = useLoader(
    TextureLoader,
    content.paragraphs.filter(({ image }) => image).map(({ image }) => image),
  )
  useMemo(() => images.forEach((texture) => (texture.minFilter = LinearFilter)), [images])
  const { contentMaxWidth: w, canvasWidth, canvasHeight, mobile } = useBlock()
  const translate = useTranslator();
  let offset = 1;
  let leftParagraph = true;

  return (
    <>
      <Block factor={1} offset={0}>
        <Block factor={1.2}>
          <Image src={logoGenosha} scaleFactor={w * 0.02} />
          <Text left size={w * 0.024} position={[-w / 2.3, w * -0.13, -1]} color="#fff" text={translate("introHeader")}/>
        </Block>
          <Block factor={1.0}>
            <Html className="bottom-left" style={{ color: "white" }} position={[-canvasWidth / 2, -canvasHeight / 2, 0]}>
              {translate("introText")}
            </Html>
          </Block>    
        
      </Block>

      {content.paragraphs.map((props, index) => {
        let paragraph = null;
        offset = getSectionOffset({ paragraphs: content.paragraphs, index, offset });

        if (props.hugeText) {
            paragraph = (
                <Block factor={props.factor} offset={offset}>
                  <MultilineText onClick={props.onClick} top left size={w * 0.05} lineHeight={w / 22} position={[-w / 2, 0, -1]} color={content.colors.hugeText} text={props.hugeText} />
                </Block>
            );
        } else {
            paragraph = <Paragraph key={index} index={index} {...props} left={leftParagraph} offset={offset} header={translate([currentPage, props.header])} text={translate([currentPage, props.text])} image={images[index]} />;
            leftParagraph = !leftParagraph;
        }

        return paragraph;
      })}
      {content.stripes.map(({ offset, color, height }, index) => (
        <Block key={index} factor={-1.5} offset={offset}>
          <Plane args={[50, height, 32, 32]} shift={-4} color={color} rotation={[0, 0, Math.PI / 8]} position={[0, 0, -10]} />
        </Block>
      ))}
      {/* <Block factor={1.25} offset={offset + 1}>
        <Html style={{ color: "white" }} className="bottom-left" position={[-canvasWidth / 2, -canvasHeight / 2, 0]}>
          Culture is not your friend.
        </Html>
      </Block> */}
    </>
  )
}
